module.exports = __webpack_public_path__ + "static/media/bg-header-GD.1e6aeac3.png";